import { h } from 'preact'
import DragHandle from '../control/DragHandle'
import ButtonControl from '../button-control'
import IconExternal from '../assets/icon-external-link'

interface Props {
  title: string
  url: string
  onDelete: () => void
}

const FeaturedTopic = ({ title, url, onDelete }: Props) => (
  <div class='featured-topic__item'>
    <div class='featured-topic__info'>
      <DragHandle />
      <p class='featured-topic__title'>{title}</p>
      <a href={url} target='_blank' class='featured-topic__link'>
        <IconExternal
          height={16}
          width={16}
        />
      </a>
    </div>
    <ButtonControl
      title='Remove'
      variant='warning'
      onClick={onDelete}
    />
  </div>
)

export default FeaturedTopic
